export default {
  testande: 'avorp850106!',
  monday: 'cahegibsun',
  january: 'meerizijwe',
  lillsjöskolan: 'citbasutov',
  lillsjöskolan2: 'lunuwagfui',
  lotestar: 'detfunkar',
}
